export default __webpack_public_path__ + "static/media/trebexia_logo.8a66eaa6.png";